import { Card, Switch } from "@mui/material";
import IcomoonReact from "icomoon-react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { SentBarcodeAnimalDto } from "../../generated/tsClient";
import iconSet from "../../icons/selection.json";

function SentBarcode(props: any) {
    const { t } = useTranslation('texts');
    const sentBarcode: SentBarcodeAnimalDto = props.sentBarcode;
    const handlePregCheckToggle = props.onPregCheckToggle;

    return (
        <Card>
            <Row>
                <Col xs="5" className="earnr-name">{sentBarcode.earNr} {sentBarcode.nameShort}</Col>
                <Col>{sentBarcode.euIdentifier + '-' + sentBarcode.euCheck}</Col>
            </Row>
            <Row>
                <Col xs="5" className="barcode"><IcomoonReact iconSet={iconSet} icon="barcode" size={20} /> {sentBarcode.barcode}</Col>
                <Col>
                    {t("List.FertilityTest")}
                    <Switch
                        checked={sentBarcode.newPregCheckOrder}
                        onChange={() => handlePregCheckToggle(sentBarcode.euIdentifier) }
                    ></Switch>
                </Col>
            </Row>
            <Row>
                <Col xs="5">{sentBarcode.lastPregCheckDate != null ? new Date(sentBarcode.lastPregCheckDate).toLocaleDateString('fi-FI', { year: 'numeric', month: '2-digit', day: '2-digit' }) + (sentBarcode.lastPregnancyCode === 1 ? " +" : " -") : ''}</Col>
                <Col>{sentBarcode.daysFromInsem != null ? t("List.InseminationDays") + ' ' + sentBarcode.daysFromInsem : ''}</Col>
            </Row>
        </Card>
    );
}

export default SentBarcode;